import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../../configs/supabase';
import { Product } from '../types/product';
import { DataFetchError } from '../../utils/ErrorClass';

interface UseProductsResult {
  products: Product[];
  error: string | null;
}

const useProducts = (productIds: number[]): UseProductsResult => {
  const [products, setProducts] = useState<Product[]>([]);
  const [error, setError] = useState<string | null>(null);

  const fetchData = useCallback(async () => {
    try {
      const { data, error } = await supabase
        .from('product')
        .select('*')
        .in('id', productIds);

      if (error) {
        throw new DataFetchError(error.message);
      }

      setProducts(data || []);
      setError(null);
    } catch (err) {
      if (err instanceof DataFetchError) {
        setError(err.message);
      } else {
        setError('An unexpected error occurred.');
      }
      console.error(err);
    }
  }, [productIds]);

  useEffect(() => {
    if (productIds.length > 0) {
      fetchData();
    }
  }, [fetchData, productIds]);

  return { products, error };
};

export default useProducts;
